import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
	AppCacheState,
	AppCacheActions	
} from "./types";
import { PersistentStorageKey } from "../common/persistentStorageKey";

export const useAppCacheStore = create<AppCacheState & AppCacheActions>()(
	persist(
		(set, get) => ({
			cache: {},
			setCache: (key: string, value: any) => {
				const oldCache = get().cache;

				if (oldCache[key] === value) {
					return;
				}

				set({
					cache: { ...oldCache, [key]: value },
				});
			},
			removeCaches: (keys: string[]) => {
				const oldCache = get().cache;

				// Compare against undefined rather than testing falsiness: cached enum
				// members are often 0 (e.g. ToggleTabType.Contacts), and treating those
				// as absent would skip the removal and leave the value in place.
				if (keys.every((x: string) => oldCache[x] === undefined)) {
					return;
				}

				const newCache = { ...oldCache };

				keys.forEach((x: string) => {
					newCache[x] = undefined;
				});

				set({ cache: newCache });
			},
		}),
		{
			name: PersistentStorageKey.AppCache,
		}
	)
);
